import { takeLatest, call, put, all } from 'redux-saga/effects';
import { ApiResponse, getApi } from 'services/_api';
import { CHANNEL, PATH_DETRAN_CRV } from 'services/_path';
import { Types } from './types';
import {
	consultarFichaCadastralSuccess,
	consultarFichaCadastralFailure,
} from './actions';

function* consultarFichaCadastralRequest(placa: any): any {
	const response: ApiResponse = yield call(
		getApi,
		PATH_DETRAN_CRV,
		`processos/${CHANNEL}/fichas-cadastrais/${placa.placa}`,
	);
	if (response.status === 200 || response.status === 201) {
		yield put(consultarFichaCadastralSuccess(response));
	} else if (response.error) {
		yield put(consultarFichaCadastralFailure(response.message));
	}
}

export default all([
	takeLatest(
		Types.CONSULTAR_FICHA_CADASTRAL_REQUEST,
		consultarFichaCadastralRequest,
	),
]);
